import { UserDTO } from '@/generated';
import { userApi } from '@/generated/clients';
import { useState } from 'react';

export const useUserProfile = () => {
  const [user, setUser] = useState<UserDTO>();
  const [error, setError] = useState<string>();

  const loadUser = async () => {
    try {
      const user = await userApi.userMe();
      setUser(user);
      setError(undefined);
      return user;
    } catch (e) {
      if (e instanceof Error) {
        setError(e.message);
      }
    }
  };
  if (!user) loadUser();

  return { user: user, error: error, refresh: async () => await loadUser() };
};
